module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/find-your-path-mobile-video-120f2edee42adbe449f33cd5556e12bd.jpg";